import { round } from 'lodash';
import { PartialBlock } from '../../BlockNoteEditor/schema';

export const getBlockType = (block: PartialBlock) =>
  'type' in block && typeof block.type === 'string' ? block.type : undefined;

export const isObjectRecord = (
  value: unknown,
): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const cssPxToPdfPt = (cssPx: number) => round((cssPx * 72) / 96, 1);
